export enum TemplateTypes {
  DataAcquisition = 'emailAcquisition',
  SendMyBasket = 'sendMyBasket',
  CartAbandonment = 'cartAbandonment',
  DisplayOnly = 'displayOnly',
}
